import { NavConfig } from './analysis-nav.component';

export const CAPTURE_NAV_CONFIG: NavConfig = {
  title: 'Capture Analysis',
  navItems: [
    {
      label: 'Project Summary',
      route: '/gene-summary',
    },
    {
      label: 'Allele Discovery',
      route: '/analytics',
      routeParams: ['Capture Probe'],
    },
    {
      label: 'Single Gene',
      route: '/gene-analytics',
      routeParams: ['Capture Probe'],
    },
    {
      label: 'Sample reads and QC',
      route: '/gene-stats',
    },
  ],
};

export const FLAIRR_NAV_CONFIG: NavConfig = {
  title: 'FLAIRR Analysis',
  navItems: [
    {
      label: 'Project Summary',
      route: '/flairr-summary',
    },
    {
      label: 'Allele Usage',
      route: '/allele-usage',
    },
    {
      label: 'Single Gene Usage',
      route: '/gene-analytics',
      routeParams: ['FLAIRR-Seq'],
    },
    {
      label: 'Allele Discovery',
      route: '/analytics',
      routeParams: ['FLAIRR-Seq'],
    },
    {
      label: 'Sample reads and QC',
      route: '/flairr-stats',
    },
  ],
};

export const PROJECT_FILES_NAV_CONFIG: NavConfig = {
  title: 'Project Files',
  navItems: [],
};
